import React from 'react'

function SponsorStatus() {
  return (
    <div>SponsorStatus</div>
  )
}

export default SponsorStatus